import { Link } from 'react-router-dom';
import { games } from '@/mocks/games';

export default function FeaturedGames() {
  const featuredGames = games.slice(0, 6);

  return (
    <section className="w-full py-16 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6">
        <div className="flex items-center justify-between mb-10">
          <div>
            <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 mb-2">
              热门推荐
            </h2>
            <p className="text-foreground-500 text-sm">精选最受欢迎的游戏</p>
          </div>
          <Link
            to="/category"
            className="hidden sm:flex items-center gap-1 text-sm text-primary-600 hover:text-primary-700 font-medium whitespace-nowrap transition-colors"
          >
            查看全部 <i className="ri-arrow-right-line text-base"></i>
          </Link>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {featuredGames.map((game) => (
            <Link
              key={game.id}
              to={`/category?tab=${game.category}`}
              className="group bg-background-50 rounded-lg overflow-hidden transition-all duration-300 hover:scale-[1.02] cursor-pointer"
            >
              <div className="relative h-48 overflow-hidden">
                <img
                  src={game.image}
                  alt={game.name}
                  className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-110"
                  title={`${game.name} - 新葡京娱乐城`}
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/50 to-transparent"></div>
                <div className="absolute top-3 left-3 flex gap-2">
                  {game.tags.map((tag) => (
                    <span
                      key={tag}
                      className="px-2 py-0.5 text-xs rounded-md bg-accent-500 text-white whitespace-nowrap"
                    >
                      {tag}
                    </span>
                  ))}
                </div>
                <div className="absolute bottom-3 left-3 right-3">
                  <span className="text-xs text-white/70 bg-black/40 px-2 py-0.5 rounded-md whitespace-nowrap">
                    {game.categoryName}
                  </span>
                </div>
              </div>
              <div className="p-4">
                <h3 className="text-base font-medium text-foreground-900 mb-2">
                  {game.name}
                </h3>
                <div className="flex items-center justify-between">
                  <div className="flex items-center gap-1">
                    <i className="ri-star-fill text-amber-400 text-sm"></i>
                    <span className="text-sm text-foreground-600">{game.rating}</span>
                  </div>
                  <span className="text-xs text-foreground-500">
                    {game.players.toLocaleString()} 人在玩
                  </span>
                </div>
              </div>
            </Link>
          ))}
        </div>

        <div className="mt-8 text-center sm:hidden">
          <Link
            to="/category"
            className="inline-flex items-center gap-1 text-sm text-primary-600 font-medium whitespace-nowrap"
          >
            查看全部游戏 <i className="ri-arrow-right-line text-base"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}